import React, { useEffect, useContext } from "react";
import { ThemeContext } from "../DarkMode/ThemeProvider";
import { useLocation, useParams } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const Tradeview = ({ classic, fullScreen, pair }) => {
  const { isLightMode } = useContext(ThemeContext);
  const theme = useTheme();
  const matchesMD = useMediaQuery(theme.breakpoints.up("md"));
  const location = useLocation();
  const { id } = useParams();
  const placeRoute = location.pathname?.split("/")[1];

  useEffect(() => {
    let newPair;

    if (placeRoute === "future") {
      newPair = `${id?.split("_")?.join("")}`;
    } else {
      newPair = `${id?.split("_")?.join("")}`;
    }

    if (newPair) {
      // Add the TradingView script if it doesn't exist
      if (!document.getElementById("tradingview-widget-script")) {
        const script = document.createElement("script");
        script.id = "tradingview-widget-script";

        // 🔥 Disable caching with a unique query string
        const timestamp = new Date().getTime();
        script.src = `https://s3.tradingview.com/tv.js?v=${timestamp}`;

        script.async = true;
        script.crossOrigin = "anonymous";
        document.body.appendChild(script);

        script.onload = () => {
          setTimeout(() => {
            if (window.TradingView) {
              initializeTradingViewWidget(newPair);
            } else {
              console.warn("TradingView not available.");
            }
          }, 100);
        };
      } else {
        // If already loaded, just initialize the widget
        setTimeout(() => {
          initializeTradingViewWidget(newPair);
        }, 100);
      }
    }

    return () => {
      const widgetContainer = document.getElementById("tradingview_chart");
      if (widgetContainer) {
        widgetContainer.innerHTML = "";
      }
    };
  }, [id, isLightMode, classic, fullScreen]);

  const initializeTradingViewWidget = (pairSymbol) => {
    const container = document.getElementById("tradingview_chart");
    if (!container || !window.TradingView) return;
    new window.TradingView.widget({
      symbol: `KUCOIN:${pairSymbol}`,
      container_id: "tradingview_chart",
      width: "100%",
      height: !matchesMD || placeRoute === "future" ? "550px" : "100%",
      theme: isLightMode ? "light" : "dark",
      interval: "D",
      timezone: "Etc/UTC",
      style: "1",
      locale: "en",
      toolbar_bg: isLightMode ? "#fff" : "#000",
      backgroundColor: isLightMode ? "#fff" : "#000",
      enable_publishing: false,
      allow_symbol_change: false,
      // Optional: You can hide other UI parts if needed
      hide_legend: true,
      trading: true,
    });
  };

  return (
    <div className="main-view">
      <div className="crt-pair">{`${id?.split("_")?.join("/")}`} 



      </div>
      
      <div
        id="tradingview_widget_container"
        style={{
          width: "100%",
          height: classic || fullScreen ? "auto" : "95%",
        }}
      >
        <div id="tradingview_chart" />
      </div>
    </div>
  );
};

export default Tradeview;
